import axios from "axios";
import { refreshTokenAPI, logoutUserAPI } from "./tokenService";

const apiClient = axios.create({
  baseURL: "https://dev-admin-api.pushkarchaubey.in/",
  timeout: 15000,
});

// === Attach access token ===
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// === Handle Unauthorized errors ===
let isRefreshing = false;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    // Only refresh on this condition
    if (
      status === 401 &&
      message === "Token is invalid!" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true; // prevent infinite loop

      try {
        if (isRefreshing) return Promise.reject(error);
        isRefreshing = true;

        const refresh_token = localStorage.getItem("refresh_token");

        // 🔄 Call refresh API (rawAxios)
        const result = await refreshTokenAPI(refresh_token);

        const newToken = result?.data?.token;
        // console.log(newToken, result, "newToken");
        if (!newToken) throw new Error("Refresh failed");

        // Save new token
        localStorage.setItem("token", newToken);

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return apiClient(originalRequest);
      } catch (err) {
        try {
          // 🔥 If refresh fails → Call logout API
          const refresh_token = localStorage.getItem("refresh_token");
          await logoutUserAPI(refresh_token);
        } catch {}

        // Clear storage and redirect
        localStorage.clear();
        window.location.href = "/login";

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
